<template>
  <v-dialog v-model="showModal" persistent max-width="1000">
    <v-card class="overflow-y-auto pa-5">
      <v-card-title class="primary--text text-h5">
        Movimentação com críticas de cadastro
      </v-card-title>

      <v-card-text class="mt-2">
        Sua movimentação apresenta uma ou mais críticas de cadatro.<br>
        Recomendamos que verifique e corrija agora, para que o registro possa prosseguir para liberação e envio à operadora,
        mas se preferir, você pode salvar a movimentação com as críticas e editar mais tarde.
      </v-card-text>

      <v-card-actions>
        <v-col>
          <v-btn v-if="viewMovementSkipCriticism" class="elevation-0" large color="muted" @click="sendRequestWithCriticism()">
            <v-icon left color="error">fas fa-long-arrow-alt-right</v-icon>
            <span class="error--text">Salvar com críticas e corrigir depois</span>
          </v-btn>
        </v-col>
        <v-spacer></v-spacer>
        <v-col>
          <v-btn large color="primary" @click="close">
            <v-icon left color="foreground-accent">fas fa-pencil-alt</v-icon>
            <span>Corrigir as críticas agora</span>
          </v-btn>
        </v-col>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import AuthorityManagementMixin from '@/shared/mixins/authorityManagement/authorityManagementMixin';

export default ({
  name: 'CriticismHandlingModal',
  data: () => ({ 
    showModal: false, 
    viewMovementSkipCriticism: false
  }),

  mixins: [
    AuthorityManagementMixin,
  ],

  methods: {
    open() {
      this.showModal = true;
      this.viewMovementSkipCriticism = this.hasPermission('sdi_mov_prosseguir_critica');
    },
    close() {
      this.showModal = false;
    },
    sendRequestWithCriticism() {
      this.$emit('confirm', true);
      this.close();
    },
  },
});
</script>
